export class TypologieContact {
    constructor(public idTypoContact: number, public libelle: string) { }
}
